export const CHUNK_LOAD_ERROR_PATTERNS = [
  /failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /^Load failed/i // Safari chunk load failure
]

export const CHUNK_RELOAD_SESSION_KEY = "chunkReloadAttempted"

export const isChunkLoadError = (message: string): boolean =>
  CHUNK_LOAD_ERROR_PATTERNS.some(pattern => pattern.test(message))
